import React, { useState } from "react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./swiper.css";
import { Link } from "react-router-dom";
import best10 from "./best10_data";
import top_data from "./top_data"
import pants_data from "./pants_data"
import shipping from "./img/shipping.png";
import {Pants_data} from "./pants_data";
import {Best10_data} from "./best10_data";
import {Top_data} from "./top_data"

interface BestItemProps {
    a : Pants_data;

    res2 : number;


}



function BsetItem():JSX.Element {
  const [best] = useState<Best10_data[]>(best10);

  const [top] = useState<Top_data[]>(top_data);

  const [pants] = useState<Pants_data[]>(pants_data);

  let [res2, setRes2] = useState<number[]>([10,12,13,14,15,16,17,18,19,20]);

  let [res3, setRes3] = useState<number[]>([10,12,13,21,14,15,17,19,20,22]);

  let [res4, setRes4] = useState<number[]>([23,24,25,26,27,28,29,30,31,32]);

  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      loop={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: true,
      }}
      pagination={{
        clickable: true,
      }}
      navigation={false}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper1"
    >
      <SwiperSlide>
        <ul style={{ display: "flex", flexWrap: "wrap" }}>
          {best.map((a:Pants_data, i:number) => {
            return <Box a={a} key={i} res2={res2[i]} />;
          })}
        </ul>
      </SwiperSlide>
      <SwiperSlide>
        <ul style={{ display: "flex", flexWrap: "wrap" }}>
          {top.map((a:Pants_data, i:number) => {
            return <Box a={a} key={i} res2={res3[i]} />;
          })}
        </ul>
      </SwiperSlide>
      <SwiperSlide>
        <ul style={{ display: "flex", flexWrap: "wrap" }}>
          {pants.map((a:Pants_data, i:number) => {
            return <Box a={a} key={i} res2={res4[i]} />;
          })}
        </ul>
      </SwiperSlide>
    </Swiper>
  );
}

function Box(props:BestItemProps):JSX.Element {
  return (
    <li className="best_item">
      <div className="bestbox">
        <div className="bestbox_img">
          <Link to={`/detail/${props.res2}`}>
            <img src={props.a.imgurl} />
          </Link>
          <div className="ranking">
            <div className="mos">{props.a.mos}</div>
          </div>
        </div>
        <div className="bestbox_txt">
          <Link to={`/detail/${props.res2}`}>
            <span className="reservation">{props.a.font}</span>
            {props.a.title}
          </Link>
          <ul>
            <li>
              <span className="persent">{props.a.persent}</span>
              <span className="saleprice">{props.a.saleprice}</span>
              <span className="price">{props.a.price}</span>
            </li>
            <li className="review">{props.a.review}</li>
            <li>
              <img src={shipping} />
            </li>
          </ul>
        </div>
      </div>
    </li>
  );
}


export default BsetItem;
